export default "__VITE_ASSET__YEl3A3I2__"